import { CartData, CartItem } from './types';

export const transformCartItems = (items: any = []) => {
  const cartItems: CartItem[] = [];

  items.forEach((item: any) => {
    const { cartItemPriceDTO = {} } = item || {};
    cartItems.push({
      id: item.productId,
      productId: item.productId,
      sku: item.sku,
      quantity: item.quantity,
      name: item.name,
      brandId: item.brandId || item.brandIds,
      categoryIds: item.categoryIds?.split(','),
      mrp: item.mrp || cartItemPriceDTO.mrp,
      offerPrice: item.price || cartItemPriceDTO.price,
      totalPrice: item.totalPrice || cartItemPriceDTO.totalPrice,
      discount: item.discount || cartItemPriceDTO.discount,
    });
  });

  return cartItems;
};

export const transformAddToCart = (data: any): CartData => {
  const { cartPriceDTO = {} } = data || {};
  const transformedData: CartData = {
    message: data.displayMessage,
    itemsCount: data.itemsCount || data.itemCount,
    itemsQuantity: data.itemsQuantity || data.quantity,
    subTotal: data.subtotal || cartPriceDTO.subtotal,
    shipping: data.shipping || cartPriceDTO.shipping,
    grandTotal: data.grandTotal || cartPriceDTO.grandTotal,
    discount: data.discount || cartPriceDTO.discount,
    items: transformCartItems(data.items),
    couponAppliedText: data.deltaAppliedCouponText,
    couponAppliedList: data.deltaAppliedCouponCodes,
    couponsApplied: data.appliedCoupons || [],
    dealDeltaText: data.deltaCommunicationDTO
      ? data.deltaCommunicationDTO.dealDeltaText
      : '',
  };

  return transformedData;
};
